import { map3d_children,home_map3d_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxMap3D = {
  name: "cxMap3D",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "3D地图",
        children: home_map3d_children,
        group: "chart",
        type: "map3DComponent",
     // enable(params) {
        //   return params.admin
        // },
        sort: 71
      }
    ],
    portal: [
      {
        name: "3D地图",
        children: home_map3d_children,
        type: "map3DComponent",
        group: "chart",
     // enable(params) {
        //   return params.admin
        // },
        sort: 71
      }
    ],
    bigScreen: [
      {
        name: "3D地图",
        children: map3d_children,
        type: "map3DComponent",
        group: "chart",
        sort: 110
      }
    ]
  },
  toolbars: [
    {
      name: "cxMap3D",
      label: "3D地图",
      comp: {
        cxMap3DData: () => import("./toolbars/map3D-options-data.vue"),
        cxMap3DSetting: () => import("./toolbars/map3D-options-setting.vue"),
        cxMap3DStyle: () => import("./toolbars/map3D-options-style.vue")
      }
    },
    {
      name: "cxMap3DScatter",
      label: "散点/气泡层",
      parentMenuName: "cxMap3D",
      comp: {
        cxMap3DScatterSetting: () => import("./toolbars/series/scatter-options-setting.vue"),
        cxMap3DScatterData: () => import("./toolbars/series/scatter-options-Data.vue")
      }
    },
    {
      name: "cxMap3DHot",
      label: "区域热力层",
      parentMenuName: "cxMap3D",
      comp: {
        cxMap3DHotSetting: () => import("./toolbars/series/hot-options-setting.vue"),
        cxMap3DHotData: () => import("./toolbars/series/hot-options-Data.vue")
      }
    },
    {
      name: "cxMap3DLines",
      label: "飞线层",
      parentMenuName: "cxMap3D",
      comp: {
        cxMap3DLinesSetting: () => import("./toolbars/series/lines-options-setting.vue"),
        cxMap3DLinesData: () => import("./toolbars/series/lines-options-Data.vue")
      }
    },
    {
      name: "cxMap3DBar",
      label: "柱状层",
      parentMenuName: "cxMap3D",
      comp: {
        cxMap3DBarSetting: () => import("./toolbars/series/bar-options-setting.vue"),
        cxMap3DBarData: () => import("./toolbars/series/bar-options-Data.vue")
      }
    }
  ]
}

export default cxMap3D
